<div class="p-3">
   <div
      class="modal-header p-0"
      style="justify-content: end; margin-top: -5px; margin-bottom: 5px">
      <button
         type="button"
         class="btn-close position-static"
         data-bs-dismiss="modal"
         aria-label="Close"
         style="padding-bottom: 4px"
         (click)="close()">
         <span aria-hidden="true">×</span>
      </button>
   </div>
   <h3>{{ title }}</h3>
   <h5>{{ message }}</h5>
   <div
      class="flex justify-content-end text-right mt-4 mb-2">
      <p-button
         icon="pi pi-times"
         (click)="close()"
         label="Dismiss"
         class="px-2"
         severity="secondary"></p-button>
      <p-button
         icon="pi pi-check"
         (click)="confirm()"
         label="Proceed Anyway"
         class="px-2"
         severity="primary"></p-button>
   </div>
</div>
